"use client";

import React from "react";
import MindalooEmblem from "@/components/mindaloo/MindalooEmblem";

interface MindalooLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  showText?: boolean;
  className?: string;
  variant?: "light" | "dark";
  isPremiumGodMode?: boolean;
}

const sizeMap = { sm: 24, md: 32, lg: 48, xl: 64 };
const textSizes = {
  sm: "text-sm",
  md: "text-lg",
  lg: "text-xl",
  xl: "text-2xl",
};

export default function MindalooLogo({
  size = "md",
  showText = true,
  className = "",
  variant = "light",
  isPremiumGodMode = false,
}: MindalooLogoProps) {
  const textColor = variant === "light" ? "text-white" : "text-[#1D1D1F]";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <MindalooEmblem
        size={sizeMap[size]}
        isPremiumGodMode={isPremiumGodMode}
      />
      {showText && (
        <span className={`${textSizes[size]} font-light tracking-[0.15em] uppercase ${textColor}`}>
          Mindaloo
        </span>
      )}
    </div>
  );
}
